import { IsNumber, IsOptional, IsString } from 'class-validator';

export class FireOpenInvoicePaymentRequestDto {
  @IsNumber()
  amount: number;

  @IsNumber()
  invoiceId: number;

  @IsNumber()
  merchantId: number;

  @IsOptional()
  @IsString()
  description?: string;

  @IsOptional()
  @IsString()
  currency?: string;

  @IsOptional()
  @IsString()
  myRef?: string;

  @IsOptional()
  @IsString()
  returnUrl?: string;

  @IsOptional()
  @IsNumber()
  paymentMethodId?: number;
}
